<div
  class="h-full bg-white flex flex-col items-center justify-center gap-4 p-8"
>
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  <div class="w-[185px] pb-4">
    <img
      class="w-full"
      [src]="cdn + '/assets/images/outlook/MaximizerLogo_Text.png'"
      alt="Maximizer logo"
    />
  </div>
  <div class="px-4 w-full">
    @if (this.login === LoginType.Cloud) {
      @if (currentStep === 1 && cloudForm) {
        <form
          class="flex flex-col items-center gap-4"
          [formGroup]="cloudForm.group"
          (ngSubmit)="proceed(true)"
        >
          <kendo-formfield class="w-full">
            <span class="text-body">{{
              'outlook.auth.login.email-label' | translate
            }}</span>
            <kendo-textbox
              id="outlook-auth-ui-loginEmail-email"
              [maxlength]="255"
              #email
              formControlName="email"
            ></kendo-textbox>
            @if (cloudForm.controls.email.touched) {
            <kendo-formerror>
              @if (cloudForm.controls.email.errors?.['required']) {
                <span>{{
                  'outlook.auth.login.email-required' | translate
                }}</span>
              }
              @if (cloudForm.controls.email.errors?.['maxlength']) {
                <span>{{
                  'outlook.forms.maxlength-error' | translate: { count: 255 }
                }}</span>
              }
              @if (
                !cloudForm.controls.email.errors?.['maxlength'] &&
                cloudForm.controls.email.errors?.['pattern']
              ) {
                <span>{{
                  'outlook.forms.valid-error'
                    | translate
                      : { fieldName: 'outlook.auth.login.email' | translate }
                }}</span>
              }
              @if (
                !cloudForm.controls.email.errors?.['maxlength'] &&
                cloudForm.controls.email.errors?.['exist']
              ) {
                <span>{{
                  'outlook.forms.exist-error'
                    | translate
                      : { fieldName: 'outlook.auth.login.email' | translate }
                }}</span>
              }
            </kendo-formerror>
            }
          </kendo-formfield>

          <span class="text-body">{{
            'outlook.auth.login.email-description' | translate
          }}</span>

          <div class="flex flex-col gap-2">
            <button
              kendoButton
              id="outlook-auth-ui-loginEmail-step1-proceed"
              type="submit"
              class="w-[200px]"
              themeColor="primary"
            >
              {{ 'outlook.buttons.proceed' | translate }}
            </button>
            <button
              kendoButton
              id="outlook-auth-ui-loginEmail-step1-back"
              (click)="goBack()"
              class="w-[200px]"
              themeColor="primary"
              fillMode="flat"
            >
              {{ 'outlook.buttons.goBack' | translate }}
            </button>
          </div>
        </form>
      }
      @if (currentStep === 2 && dbForm) {
        <div class="flex flex-col items-center gap-4">
          <div class="w-full">
            <span class="text-body">{{
              'outlook.auth.login.database' | translate
            }}</span>
            <kendo-dropdownlist
              id="outlook-auth-ui-loginEmail-database"
              [data]="dropdownDbs"
              textField="text"
              valueField="tenantId"
              [(ngModel)]="selectedDatabase"
            ></kendo-dropdownlist>
          </div>

          <span class="text-body">{{
            'outlook.auth.login.database-description' | translate
          }}</span>

          <div class="flex flex-col gap-2">
            <button
              kendoButton
              id="outlook-auth-ui-loginEmail-step2-proceed"
              class="w-[200px]"
              themeColor="primary"
              (click)="navigateToOAuth2()"
            >
              {{ 'outlook.buttons.proceed' | translate }}
            </button>
            <button
              kendoButton
              id="outlook-auth-ui-loginEmail-step2-back"
              (click)="goBack()"
              class="w-[200px]"
              themeColor="primary"
              fillMode="flat"
            >
              {{ 'outlook.buttons.goBack' | translate }}
            </button>
          </div>
        </div>
      }
    } @else if (this.login === LoginType.OnPrem && onPremForm) {
      <form
        class="flex flex-col items-center gap-4"
        [formGroup]="onPremForm.group"
      >
        <kendo-formfield class="w-full">
          <span class="text-body"
            >{{ 'outlook.auth.login.hostServer' | translate }}*</span
          >
          <kendo-textbox
            id="outlook-auth-ui-loginEmail-hostServer"
            formControlName="hostServer"
          ></kendo-textbox>
          <kendo-formerror>
            @if (onPremForm.controls.hostServer.hasError('required')) {
              <span>{{ 'outlook.forms.requiredField' | translate }}</span>
            }
            @if (onPremForm.controls.hostServer.hasError('notFound')) {
              <span>{{
                'outlook.auth.login.hostServerError' | translate
              }}</span>
            }
            @if (onPremForm.controls.hostServer.hasError('pattern')) {
              <span>{{
                'outlook.auth.login.hostInvalidFormat' | translate
              }}</span>
            }
          </kendo-formerror>
        </kendo-formfield>

        <p class="text-body whitespace-pre self-start w-full">
          {{ 'outlook.auth.login.hostServerDescription' | translate }}
        </p>

        <button
          kendoButton
          id="outlook-auth-ui-loginEmail-step1-connect"
          type="submit"
          class="w-[200px]"
          themeColor="primary"
          [disabled]="!onPremForm.valid || loading"
          (click)="connect()"
        >
          {{ 'outlook.buttons.connect' | translate }}
        </button>
      </form>
    }
  </div>
</div>
